import payTypes from "../../../utils/payType";

const initialState = {
  address: {}, // 选中的地址
  addressList: [],
  addressQuery: {}, // 编辑时的地址
  formVisible: false,
  addressListModalVisible: false,
  payType: 3,
  expressFee: 0,
  expressType: 2,
  shopList: [],
  shopInfo: {},
  coupon: {},
  couponList: [],
  couponListModalVisible: false,
  billData: {
    totalPrice: 0,
    goodsTotolPrice: 0,
    goodsCount: 0,
    discountAmount: 0,
  },
  payTypeList: payTypes
};

function reducer(state, action) {
  switch (action.type) {
    case 'setAddress':
      return { ...state, address: action.payload };
    case 'setAddressList':
      return { ...state, addressList: action.payload };
    case 'setAddressQuery':
      return { ...state, addressQuery: action.payload };
    case 'setFormVisible':
      return { ...state, formVisible: action.payload };
    case 'setPayType':
      return { ...state, payType: action.payload };
    case 'setExpressFee':
      return { ...state, expressFee: action.payload };
    case 'setBillData':
      return { ...state, billData: action.payload };
    case 'setShopList':
      return { ...state, shopList: action.payload };
    case 'setShopInfo':
      return { ...state, shopInfo: action.payload };
    case 'setExpressType':
      return { ...state, expressType: action.payload };
    case 'setAddressListModalVisible':
      return { ...state, addressListModalVisible: action.payload };
    case 'setCoupon':
      return { ...state, coupon: action.payload };
    case 'setCouponList':
      return { ...state, couponList: action.payload };
    case 'setCouponListModalVisible':
      return { ...state, couponListModalVisible: action.payload };
    default:
  }
}

const setAddressListModalVisible = payload => ({
  type: 'setAddressListModalVisible',
  payload,
});

const setAddress = payload => ({
  type: 'setAddress',
  payload,
});

const setAddressList = payload => ({
  type: 'setAddressList',
  payload,
});

const setAddressQuery = payload => ({
  type: 'setAddressQuery',
  payload,
});

const setFormVisible = payload => ({
  type: 'setFormVisible',
  payload,
});

const setPayType = payload => ({
  type: 'setPayType',
  payload,
});

const setExpressFee = payload => ({
  type: 'setExpressFee',
  payload,
});

const setBillData = payload => ({
  type: 'setBillData',
  payload,
});

const setShopList = payload => ({
  type: 'setShopList',
  payload,
});

const setShopInfo = payload => ({
  type: 'setShopInfo',
  payload,
});

const setExpressType = payload => ({
  type: 'setExpressType',
  payload,
});

const setCoupon = payload => ({
  type: 'setCoupon',
  payload,
});

const setCouponList = payload => ({
  type: 'setCouponList',
  payload,
});

const setCouponListModalVisible = payload => ({
  type: 'setCouponListModalVisible',
  payload,
});


export {
  initialState,
  reducer,
  setAddress,
  setAddressList,
  setAddressQuery,
  setFormVisible,
  setPayType,
  setExpressFee,
  setBillData,
  setShopList,
  setShopInfo,
  setExpressType,
  setCoupon,
  setCouponList,
  setCouponListModalVisible,
  setAddressListModalVisible
};
